import { EMPLOYMENT_TYPES } from '@src/constants';
import { OpeningCandidateDestinationTypeEnum, OpeningQueryQuery } from '@src/graphql/generated';
import { COMMENT_MIN_LENGTH, MESSAGE_MIN_LENGTH, PITCH_MIN_LENGTH } from '../constants/textLength';

export function isTargetEnabled(): boolean {
  return true;
}

export function isSalaryRangeComplete(opening: OpeningQueryQuery['opening']): boolean {
  const { employmentType } = opening;

  let { salaryRange } = opening;
  salaryRange = salaryRange || {};

  const hasSalaryRange = !!(salaryRange && salaryRange.from && salaryRange.to);

  return employmentType === EMPLOYMENT_TYPES.INTERNSHIP.key || !!hasSalaryRange;
}

export function isMessageEnabled(opening: OpeningQueryQuery['opening']): boolean {
  if (!isSalaryRangeComplete(opening)) {
    return false;
  }

  return !!(opening.title && opening.skills?.length && opening?.speciality);
}

export function isApplicationEnabled(opening: OpeningQueryQuery['opening']): boolean {
  if (!isMessageEnabled(opening)) {
    return false;
  }

  return !!(
    opening.message &&
    opening.message.length >= MESSAGE_MIN_LENGTH &&
    opening.comment &&
    opening.comment.length >= COMMENT_MIN_LENGTH
  );
}

export function isPitchEnabled(opening: OpeningQueryQuery['opening']): boolean {
  if (!isApplicationEnabled(opening)) {
    return false;
  }

  if (opening.candidateDestination.type === OpeningCandidateDestinationTypeEnum.MEETFRANK) {
    return !!opening.automatedResponse;
  }

  if (opening.candidateDestination.type === OpeningCandidateDestinationTypeEnum.EXTERNAL_URL) {
    return !!opening.candidateDestination.url && opening.candidateDestination.url.trim() !== '';
  }

  return false;
}

export function isReviewEnabled(opening: OpeningQueryQuery['opening']): boolean {
  if (!isPitchEnabled(opening)) {
    return false;
  }

  return !!(opening.pitch && opening.pitch.length >= PITCH_MIN_LENGTH);
}
